function loadDelayedScripts () {
  const delayedScripts = document.querySelectorAll('script[data-script-src]')
  delayedScripts.forEach(script => {
    if (!script.src) {
      const extraDelay = script.getAttribute('data-extra-delay') || 0
      setTimeout(() => {
        script.src = script.getAttribute('data-script-src')
      }, extraDelay)
    }
  })
}

function initUserInteractionListeners () {
  const interactionEvents = ['mousemove', 'scroll', 'touchstart', 'keydown']
  let interactionDetected = false

  const interactionHandler = () => {
    interactionDetected = true
    interactionEvents.forEach(event => window.removeEventListener(event, interactionHandler))
    setTimeout(() => {
      if (interactionDetected) {
        loadDelayedScripts()
      }
    }, 2000)
  }

  interactionEvents.forEach(event => window.addEventListener(event, interactionHandler))
}

window.addEventListener('load', () => {
  initUserInteractionListeners()
  setTimeout(() => {
    if (!document.querySelector('script[src]')) {
      loadDelayedScripts()
    }
  }, 5000)
})
